export type Publication = {
  title: string;
  richtitle: any;
  slug: string;
  description?: string;
  contentType?: string;
  region?: string;
  contentTheme?: string;
  featuredImage?: {
    alt?: string;
    url: string;
  };
  publicationType: PublicationType;
  midia?: {
    alt?: string;
    url: string;
    mimeType: string;
    filesize: number;
  };
  youtubeUrl?: string;
  contentText?: string;
  publishedAt?: string;
  updatedAt?: string;
};

export enum PublicationType {
  IMAGE = 'image',
  VIDEO = 'video',
  PRESS_RELEASE = 'pressRelease',
}

export type PublicationsResponse = {
  Publications: {
    docs: Publication[];
    page: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    limit: number;
    nextPage: number | null;
    totalPages?: number;
  };
};

export type GetPublicationsOptions = {
  locale?: string;
  pagination?: boolean;
  limit?: number;
  page?: number;
  sort?: string;
  where?: any;
};

export type PublicationsQueryVariables = {
  sort: string;
  locale?: string;
  where?: any;
  limit?: number;
  page?: number;
};

export type PublicationsData = {
  items: Publication[];
  type?: PublicationType;
  pagination?: {
    page: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    limit: number;
    nextPage: number | null;
    totalPages?: number;
  };
};